module.exports = __webpack_public_path__ + "assets/images/green-xmas-5.jpg?v=ae5eb0a5";